import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowUpLeftSm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m8 14.777.094-6.683m0 0L14.777 8m-6.683.094L16 16"
    />
  </svg>
);
export default SvgArrowUpLeftSm;
